"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const TableTotals = ((props) => (react_2.default.createElement(react_1.Box, { borderColor: "border", borderWidth: "1px", ...props })));
const TableTotalsRow = (props) => (react_2.default.createElement(react_1.Flex, { alignItems: "center", gap: "space-10", justifyContent: "space-between", padding: "space-8", ...props }));
TableTotals.Row = TableTotalsRow;
exports.default = TableTotals;
